import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-sports',
  templateUrl: './sports.component.html',
  styleUrls: ['./sports.component.scss'],
  standalone: false,
})
export class SportsComponent {
  @Input() school: any = {};
  displayedSports: any = [];
  sportsData: any = [
    {
      logo: '../../assets/images/cricket.png',
      title: 'Cricket',
      key: 'cricket',
    },
    {
      logo: '../../assets/images/chess.png',
      title: 'Chess',
      key: 'chess',
    },
    {
      logo: '../../assets/images/shooting.png',
      // logo: '../../assets/images/cricket.png',
      title: 'Shooting',
      key: 'shooting',
    },
    {
      logo: '../../assets/images/football.png',
      title: 'Football',
      key: 'football',
    },
    {
      logo: '../../assets/images/swimming.png',
      title: 'Swimming',
      key: 'swimming',
    },
    {
      logo: '../../assets/images/athletics.png',
      title: 'Athletics',
      key: 'athletics',
    },
    {
      logo: '../../assets/images/gymnastics.png',
      // logo: '../../assets/images/cricket.png',
      title: 'Gymnastics',
      key: 'gymnastics',
    },
    {
      logo: '../../assets/images/kabaddi.png',
      title: 'Kabaddi',
      key: 'kabbadi',
    },
    {
      logo: '../../assets/images/baseball.png',
      // logo: '../../assets/images/cricket.png',
      title: 'Baseball',
      key: 'baseball',
    },
    {
      logo: '../../assets/images/basketball.png',
      // logo: '../../assets/images/cricket.png',
      title: 'Basketball',
      key: 'basketball',
    },
    {
      logo: '../../assets/images/tennis.png',
      title: 'Tennis',
      key: 'tennis',
    },
    {
      logo: '../../assets/images/tabletennis.png',
      title: 'TableTennis',
      key: 'tableTennis',
    },
    {
      logo: '../../assets/images/voleyball.png',
      title: 'Voleyball',
      key: 'voleyBall',
    },

    {
      logo: '../../assets/images/golf.png',
      title: 'Golf',
      key: 'golf',
    },
    {
      logo: '../../assets/images/badminton.png',
      title: 'Badminton',
      key: 'badminton',
    },
    {
      logo: '../../assets/images/karate.png',
      title: 'Karate',
      key: 'karate',
    },
    {
      logo: '../../assets/images/boxing.png',
      title: 'Boxing',
      key: 'boxing',
    },
    {
      logo: '../../assets/images/archery.png',
      // logo: '../../assets/images/cricket.png',
      title: 'Archery',
      key: 'archery',
    },
  ];

  ngOnInit(): void {
    this.filterSports();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['school'] && changes['school'].currentValue) {
      // setTimeout(() => this.filterSports(), 100);
      this.filterSports();
    }
  }

  filterSports(): void {
    const sports = this.school.sports || {};
    this.displayedSports = this.sportsData.filter(
      (sport) => sports[sport.key] === true
    );
    if (this.displayedSports.length === 0) {
      this.displayedSports = this.sportsData.slice(0, 4);
    }
  }
}
